import * as d3 from "d3"


export function generateTitle(containerId) {
    const letterData = {
        "C": {
            points: [
                {x: 90, y: 20}, // Top right
                {x: 50, y: 10}, // Top middle
                {x: 10, y: 20}, // Top left
                {x: 10, y: 60}, // Bottom left
                {x: 50, y: 70}, // Bottom middle
                {x: 90, y: 60}  // Bottom right
            ],
            edges: [
                {source: 0, target: 1}, // Start of the top curve
                {source: 1, target: 2}, // Completion of the top curve
                {source: 2, target: 3}, // Left downward stroke
                {source: 3, target: 4}, // Start of the bottom curve
                {source: 4, target: 5}  // Completion of the bottom curve
            ]
        },
        "O": {
            points: [{x: 10, y: 40}, {x: 50, y: 10}, {x: 90, y: 40}, {x: 50, y: 70}],
            edges: [{source: 0, target: 1}, {source: 1, target: 2}, {source: 2, target: 3}, {source: 3, target: 0}]
        },
        "N": {
            points: [{x: 10, y: 70}, {x: 10, y: 10}, {x: 90, y: 70}, {x: 90, y: 10}],
            edges: [{source: 0, target: 1}, {source: 1, target: 2}, {source: 2, target: 3}]
        },
        "S": {
            points: [
                {x: 80, y: 10}, // Start top right
                {x: 20, y: 10}, // Move to top left
                {x: 10, y: 30}, // Curve down left top
                {x: 40, y: 40}, // Middle transition
                {x: 80, y: 40}, // Curve up right bottom
                {x: 70, y: 70}, // Move to bottom left
                {x: 10, y: 70}  // End bottom right
            ],
            edges: [
                {source: 0, target: 1}, // Top horizontal line
                {source: 1, target: 2}, // Upper left curve
                {source: 2, target: 3}, // Left to middle
                {source: 3, target: 4}, // Middle to right curve
                {source: 4, target: 5}, // Right bottom curve up
                {source: 5, target: 6}  // Bottom horizontal line
            ]
        },
        "T": {
            points: [
                {x: 10, y: 10}, // Top left
                {x: 90, y: 10}, // Top right
                {x: 50, y: 15}, // Middle top (intersection)
                {x: 50, y: 70}  // Bottom middle
            ],
            edges: [
                {source: 1, target: 2}, // Top horizontal line (right half)
                {source: 2, target: 0}, // Top horizontal line (left half)
                {source: 2, target: 3}  // Middle down to bottom
            ]
        }
        ,
        "E": {
            points: [{x: 90, y: 10}, {x: 10, y: 10}, {x: 15, y: 40}, {x: 50, y: 40}, {x: 10, y: 70}, {x: 90, y: 70}],
            edges: [{source: 0, target: 1}, {source: 1, target: 2}, {source: 2, target: 3}, {
                source: 2,
                target: 4
            }, {source: 4, target: 5}]
        },
        "L": {
            points: [{x: 10, y: 10}, {x: 10, y: 70}, {x: 90, y: 70}],
            edges: [{source: 0, target: 1}, {source: 1, target: 2}]
        },
        "A": {
            points: [
                {x: 10, y: 70}, // Bottom left
                {x: 50, y: 10}, // Top peak
                {x: 90, y: 70}, // Bottom right
                {x: 50, y: 50}, // Crossbar left
            ],
            edges: [
                {source: 0, target: 1}, // Left leg
                {source: 1, target: 2}, // Right leg
                {source: 2, target: 3}, // Move from bottom right to crossbar left
            ]
        },
        "I": {
            points: [{x: 50, y: 10}, {x: 50, y: 70}],
            edges: [{source: 0, target: 1}]
        }
    };


// Parameters for point radius variability
    let n = 3; // Minimum radius
    let m = 6; // Maximum radius

// Function to draw a letter
    function drawLetter(svg, letter, xOffset, randScale) {
        // Draw the points as circles
        let letterpoints = letterData[letter].points

        letterpoints.forEach(point => {
            point.x = point.x + Math.random() * randScale
            point.y = point.y + Math.random() * randScale
        })


        // Draw the edges as lines
        letterData[letter].edges.forEach(edge => {
            let source = (letterpoints[edge.source]);
            let target = (letterpoints[edge.target]);

            svg.append("line")
                .attr("class", "constellation-line")
                .attr("x1", source.x + xOffset)
                .attr("y1", source.y)
                .attr("x2", target.x + xOffset)
                .attr("y2", target.y)
                .style("stroke", "white")
                .style("stroke-width", 2)
                .attr("stroke-opacity", 0);
        });

        svg.selectAll(".point-" + letter + xOffset)
            .data(letterpoints)
            .enter()
            .append("circle")
            .attr("class", "point-" + letter)
            .attr("cx", d => d.x + xOffset)
            .attr("cy", d => d.y)
            .attr("r", () => n + Math.random() * (m - n))
            .style("fill", "white");
    }


// Example: Draw the word CONSTELLATION
    let xOffset = 0;
    let spacing = 120; // Spacing between letters
    let randScale = 10

// Create the SVG container
    let svg = d3.select(`#${containerId}`).append("svg")
        .style("background", "#101010")
        .attr("width", 13 * 120)
        .attr("height", 100)
        .classed("constellation", true);

    "CONSTELLATION".split('').forEach(letter => {
        drawLetter(svg, letter, xOffset, randScale);
        xOffset += spacing;
    });

// Define the glow filter within the SVG
    let defs = svg.append("defs");
    let filter = defs.append("filter")
        .attr("id", "glow-filter")
        .attr("height", "300%")
        .attr("width", "300%");
    filter.append("feGaussianBlur")
        .attr("stdDeviation", "1.0")
        .attr("result", "coloredBlur");
    let feMerge = filter.append("feMerge");
    feMerge.append("feMergeNode").attr("in", "coloredBlur");
    feMerge.append("feMergeNode").attr("in", "SourceGraphic");

// Select all the circles and apply the glow effect and atmospheric vibration
    svg.selectAll("circle")
        .classed("glow", true) // Apply the glow effect

// After all letters are drawn with their points and initial invisible lines:
    svg.selectAll(".constellation-line")
        .transition()
        .delay((d, i) => 100 + i * 25) // Adjust delay as necessary
        .duration(250)
        .attr("stroke-opacity", 1); // Fade in the lines

    return svg
}